import { z } from 'zod';

export const createRegistrationSchema = (t: (key: string) => string) =>
  z
    .object({
      email: z
        .string()
        .min(1, t('common:errors.required'))
        .email(t('common:errors.email')),
      password: z.string().min(1, t('common:errors.required')),
      confirmPassword: z.string().min(1, t('common:errors.required')),
      phone: z
        .string()
        .min(1, t('common:errors.required'))
        .min(7, t('common:errors.phoneFormat')),
      accept_ula: z.boolean().refine((val) => val, {
        message: t('common:errors.acceptULA'),
      }),
      accept_pd: z.boolean().refine((val) => val, {
        message: t('common:errors.acceptPD'),
      }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('common:errors.sameAsPassword'),
      path: ['confirmPassword'],
    });

export const createLoginSchema = (t: (key: string) => string) =>
  z.object({
    email: z
      .string()
      .min(1, t('common:errors.required'))
      .email(t('common:errors.email')),
    password: z.string().min(1, t('common:errors.required')),
  });

export const createResetPasswordSchema = (t: (key: string) => string) =>
  z
    .object({
      code: z
        .string()
        .regex(/^[0-9]{6}$/, t('auth:resetPassword.code.error')),
      password: z.string().min(1, t('common:errors.required')),
      confirmPassword: z.string().min(1, t('common:errors.required')),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('common:errors.sameAsPassword'),
      path: ['confirmPassword'],
    });

export const createForgotPasswordSchema = (t: (key: string) => string) =>
  z.object({
    email: z
      .string()
      .min(1, t('common:errors.required'))
      .email(t('common:errors.email')),
  });
